<button [hlmDropdownMenuTrigger]="menu" hlmBtn variant="ghost" size="xxl">
  <img ngSrc="/avatar.png" alt="Avatar" width="20" height="20" />
</button>

<ng-template #menu>
  <hlm-dropdown-menu>
    <hlm-dropdown-menu-group>
      <button (click)="deconnexion()" hlmDropdownMenuItem>Déconnexion</button>
    </hlm-dropdown-menu-group>
  </hlm-dropdown-menu>
</ng-template>
